import * as Yup from 'yup';

export default Yup.object().shape({
  name: Yup.string().required('SCHEMA_ERRORS.EQUIPMENT_TYPE_REQUIRED'),
  productKey: Yup.string().required('SCHEMA_ERRORS.PRODUCT_KEY_REQUIRED')
});
